// Web builds resolve this file; Metro resolves is-web.native.ts. Avoids importing
// react-native (aliased to react-native-web, ~80 ms per web test file) just to read Platform.OS.
export function isWeb() {
  return true;
}
